<template lang="pug">
div
  v-row
    v-col(cols="12" md="4")
      yc-text-field(:label="$t('type_in_segment_name')" v-model="compTitle" validate-on-blur)
  v-row(no-gutters)
    v-col(cols="12" md="6")
      yc-text-area(:label="$t('description_optional')" v-model="compDescription")
  v-btn.mt-8.button-Aa-large.px-6.rounded-lg(@click="clickContinue" color="info" depressed height=48 :disabled="!compTitle.trim().length") {{ $t('continue') }}
</template>

<script>
export default {
  props: ['title', 'description'],
  data: () => ({
    rules: {
      not_empty: [v => v.trim().length || 'This field is required']
    }
  }),
  computed: {
    compTitle: {
      get () {
        return this.title
      },
      set (newValue) {
        this.$emit('update:title', newValue)
      }
    },
    compDescription: {
      get () {
        return this.description
      },
      set (newValue) {
        this.$emit('update:description', newValue)
      }
    }
  },
  methods: {
    clickContinue () {
      this.$emit('click')
    }
  }
}
</script>

